import React from 'react';

function Footer(){
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col">
            
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
